<template>
  <div class="community column">
    <div class="divider"></div>
    <iframe
      height="315"
      frameborder="0"
      allowfullscreen
      src="https://www.youtube.com/embed/J4RpDRgFveU"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
    ></iframe>
    <br />
    <br />
    <a class="row justify-center" :href="user.ns_academy" target="_blank">
      <button class="button button-green-dark">CONTINUAR PARA O PRODUTO</button>
    </a>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      
    }
  },
  computed: {
    ...mapGetters("user", ["user"])
  }
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;
.community {
  padding-top: 25px;
  color: $gray-6;
  padding: 10px 30px;
  padding-top: 25px;
  padding-bottom: 25px;
  @media (min-width: $small) {
    /* width: 50%; */
    width: 600px;
  }
  iframe {
    width: 100%;
    min-height: 100%;
  }
}
</style>